import { combineReducers } from 'redux';
import ocorrencias from './slices/ocorrencias.slice';

const reducer = combineReducers({
  ocorrencias
})

export default reducer;
